// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M6.46517 17.4063L2.75 20.25M17.5348 17.4063L21.25 20.25M1 4H23V17C15.6667 17 8.33333 17 1 17V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"tv-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 4H23V17C15.6667 17 8.33333 17 1 17V4Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.46517 17.4063L2.75 20.25M17.5348 17.4063L21.25 20.25M1 4H23V17C15.6667 17 8.33333 17 1 17V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Tv1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tv-1',
    ref,
    icon: element,
  },
));

Tv1Icon.displayName = 'Tv1Icon';

export default Tv1Icon;
